import { useMediaQuery } from "@mui/material";

export const useScreenWidth = (size: string) => {
	return useMediaQuery((theme: any) => theme.breakpoints.up(size));
};
